/* cl-coll.js — colecao copiada do tema dele (build_collection.py).
   Masquer/afficher les filtres (gaveta no mobile), acordeoes da barra lateral, "Montre plus",
   menu Trier (links ?sort_by=), 1-4 colunas, e os filtros no cliente sobre os cards da grade
   (disponibilidade, faixa de preco com as duas bolinhas, cor). */
(function () {
  'use strict';
  function init(root) {
    if (root._clColl) return; root._clColl = 1;   // o <script> vem nas duas copias (desktop/mobile)
    var aside = root.querySelector('[data-collection-sidebar]');
    var grid = root.querySelector('.js-grid');
    var items = grid ? [].slice.call(grid.querySelectorAll('[data-cl-price]')) : [];
    var mobile = function () { return window.matchMedia('(max-width: 767px)').matches; };

    // filtros: mostrar/esconder (desktop) ou gaveta (mobile)
    root.querySelectorAll('[data-filters-toggle]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (!aside) return;
        if (mobile()) {
          var open = !aside.classList.contains('cl-drawer-open');
          aside.classList.toggle('cl-drawer-open', open);
          aside.style.cssText = open ? 'display:block;position:fixed;inset:0;z-index:1060;overflow:auto;background:var(--COLOR-BG,#FFF8F3);padding:20px;transform:none;visibility:visible;opacity:1' : '';
          document.documentElement.style.overflow = open ? 'hidden' : '';
        } else {
          var off = !aside.classList.contains('cl-filters-off');
          aside.classList.toggle('cl-filters-off', off);
          root.querySelectorAll('.collection__filters__toggle').forEach(function (t) {
            t.setAttribute('aria-expanded', off ? 'false' : 'true');
            t.classList.toggle('drawer--visible', !off);
            var hs = t.querySelector('.hide-filters'), ss = t.querySelector('.show-filters');
            if (hs && ss) { hs.style.display = off ? 'none' : ''; ss.style.display = off ? 'inline' : ''; }
          });
        }
      });
    });
    var ul = root.querySelector('[data-filters-underlay]');
    ul && ul.addEventListener('click', function () { if (aside && aside.classList.contains('cl-drawer-open')) { aside.classList.remove('cl-drawer-open'); aside.style.cssText = ''; document.documentElement.style.overflow = ''; } });
    // acordeoes da barra lateral: motor herdado (cl-interactions.js, [data-accordion-trigger])
    // Montre plus
    root.querySelectorAll('[data-show-more]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var on = !b.classList.contains('cl-more');
        b.classList.toggle('cl-more', on);
        b.parentElement.querySelectorAll('.sidebar__item.is-hidden').forEach(function (i) { i.classList.toggle('cl-shown', on); });
        b.textContent = on ? 'Montre moins' : 'Montre plus';
      });
    });
    // Trier
    var pt = root.querySelector('[data-popout-toggle]'), pl = root.querySelector('[data-popout-list]');
    if (pt && pl) {
      pt.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); var o = !pl.classList.contains('cl-open'); pl.classList.toggle('cl-open', o); pt.setAttribute('aria-expanded', o ? 'true' : 'false'); });
      document.addEventListener('click', function (e) { if (!e.target.closest('[data-popout]')) { pl.classList.remove('cl-open'); pt.setAttribute('aria-expanded', 'false'); } });
    }
    // colunas
    root.querySelectorAll('[data-toggle-grid]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var n = b.getAttribute('data-toggle-grid');
        if (mobile()) grid.setAttribute('data-grid-small', n); else grid.setAttribute('data-grid-large', n);
        root.querySelectorAll('[data-toggle-grid]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      });
    });

    // ---- filtros no cliente ----
    var form = root.querySelector('[data-sidebar-filter-form]');
    if (!form || !items.length) return;
    form.addEventListener('submit', function (e) { e.preventDefault(); });
    var minIn = form.querySelector('[data-field-price-min]'), maxIn = form.querySelector('[data-field-price-max]');
    var slider = form.querySelector('[data-range-slider]');
    var maxV = slider ? +slider.getAttribute('data-se-max') || 0 : 0;
    // cores que nao existem nesta colecao saem da lista
    var present = {};
    items.forEach(function (it) { var c = it.getAttribute('data-cl-color'); if (c) present[c] = 1; });
    form.querySelectorAll('input[name="filter.v.option.couleur"]').forEach(function (i) {
      var li = i.closest('li'); if (li && !present[i.value]) li.style.display = 'none';
    });
    function apply() {
      var av = [].map.call(form.querySelectorAll('input[name="filter.v.availability"]:checked'), function (i) { return i.value; });
      var cols = [].map.call(form.querySelectorAll('input[name="filter.v.option.couleur"]:checked'), function (i) { return i.value; });
      var lo = minIn && minIn.value !== '' ? +minIn.value * 100 : -1, hi = maxIn && maxIn.value !== '' ? +maxIn.value * 100 : Infinity;
      var shown = 0, prods = {};
      items.forEach(function (it) {
        var p = +it.getAttribute('data-cl-price'), a = it.getAttribute('data-cl-available'), c = it.getAttribute('data-cl-color');
        var ok = (!av.length || av.indexOf(a) >= 0) && (!cols.length || cols.indexOf(c) >= 0) && p >= lo && p <= hi;
        var card = it.closest('.product-grid-item, cl-product-grid-item') || it;
        if (ok) { card.removeAttribute('data-cl-hidden'); shown++; prods[it.getAttribute('data-cl-handle')] = 1; } else card.setAttribute('data-cl-hidden', '');
      });
      var cnt = root.querySelector('[data-products-count] strong'); if (cnt) cnt.textContent = Object.keys(prods).length;
      var n = av.length + cols.length + ((lo > 0 || hi < Infinity) ? 1 : 0);
      var badge = root.querySelector('[data-active-filters-count]'); if (badge) badge.textContent = n ? '(' + n + ')' : '';
    }
    form.addEventListener('change', apply);
    form.addEventListener('input', function (e) { if (e.target === minIn || e.target === maxIn) { syncDots(); apply(); } });
    // faixa de preco: bolinhas arrastaveis
    var dl = slider && slider.querySelector('[data-range-left]'), dr = slider && slider.querySelector('[data-range-right]'), line = slider && slider.querySelector('[data-range-line]');
    function width() { var l = slider.querySelector('.range__line'); return (l || slider).clientWidth || 210; }
    function syncDots() {
      if (!slider || !maxV) return;
      var W = width(), a = minIn.value === '' ? 0 : +minIn.value, b = maxIn.value === '' ? maxV : +maxIn.value;
      var x1 = Math.max(0, Math.min(W, a / maxV * W)), x2 = Math.max(0, Math.min(W, b / maxV * W));
      dl.style.left = x1 + 'px'; dr.style.left = x2 + 'px';
      if (line) { line.style.marginLeft = x1 + 'px'; line.style.width = (x2 - x1) + 'px'; }
    }
    function drag(dot, isLeft) {
      if (!dot) return;
      dot.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        var r = slider.querySelector('.range__line') || slider, box = r.getBoundingClientRect();
        function mv(ev) {
          var v = Math.round(Math.max(0, Math.min(1, (ev.clientX - box.left) / box.width)) * maxV);
          if (isLeft) { var hiV = maxIn.value === '' ? maxV : +maxIn.value; minIn.value = Math.min(v, hiV); }
          else { var loV = minIn.value === '' ? 0 : +minIn.value; maxIn.value = Math.max(v, loV); }
          syncDots(); apply();
        }
        function up() { document.removeEventListener('pointermove', mv); document.removeEventListener('pointerup', up); }
        document.addEventListener('pointermove', mv); document.addEventListener('pointerup', up);
      });
    }
    drag(dl, true); drag(dr, false);
  }
  function boot() { document.querySelectorAll('.cl-sec-c01d, .cl-sec-c01m').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
